/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'confluence-analytics-chart.default-loading-text': "Actualisation des données d'analyse…",
  'confluence-analytics-chart.tooltip.no-views-data': 'Aucune donnée',
  'confluence-analytics-chart.tooltip.views-overall': '{count, plural, one {1 vue} other {{count} vues}}',
  'confluence-analytics-chart.tooltip.views-today-so-far':
    "{count, plural, one {1 vue jusqu'à présent} other {{count} vues jusqu'à présent}}",
  'confuence-analytics-chart.accessible-table.caption': 'Vues de la page',
  'confuence-analytics-chart.accessible-table.header.date': 'Date',
  'confuence-analytics-chart.accessible-table.header.view-count': 'Vues',
  'confuence-analytics-chart.accessible-table.no-view-count-data': 'Aucune vue',
};
